import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPrevealAnswer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M23 20.9515V11.1L18.125 6H11.625C10.7312 6 10.0081 6.765 10.0081 7.7L10 21.3C10 22.235 10.7231 23 11.6169 23H21.375C21.7406 23 22.0656 22.8725 22.3419 22.66L18.7425 18.8945C18.0925 19.3365 17.3288 19.6 16.5 19.6C14.2575 19.6 12.4375 17.696 12.4375 15.35C12.4375 13.004 14.2575 11.1 16.5 11.1C18.7425 11.1 20.5625 13.004 20.5625 15.35C20.5625 16.217 20.3106 17.016 19.8881 17.6875L23 20.9515ZM14.0625 15.35C14.0625 16.761 15.1512 17.9 16.5 17.9C17.8488 17.9 18.9375 16.761 18.9375 15.35C18.9375 13.939 17.8488 12.8 16.5 12.8C15.1512 12.8 14.0625 13.939 14.0625 15.35Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.94915 8.64189L7.57627 7.21892C7.38418 6.53964 7.19774 5.83694 7.01695 5.11081C6.84746 4.38468 6.66667 3.67027 6.47458 2.96757H6.40678C6.24859 3.68198 6.0791 4.40225 5.89831 5.12838C5.71751 5.84279 5.53107 6.53964 5.33898 7.21892L4.9661 8.64189H7.94915ZM8.49153 10.6622H4.42373L3.54237 14H1L5.01695 1H7.9661L12 14H9.37288L8.49153 10.6622Z",
		fill: "black"
	})]
});
export default SvgIconPrevealAnswer;
